// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Container } from './container';
import { DropdownManager } from './dropdown-manager';
import { DropdownItem } from './dropdown';
import { Tooltip } from './tooltip';

/**
 * @class Jsw.ResponsiveDropdown
 * @extends Jsw.Container
 */
export const ResponsiveDropdown = Class.create(Container, {
    _initConfiguration($super, config) {
        $super(config);
        this._contentAreaId = `${this._id}-content-area`;
        this._cls = this._getConfigParam('cls', 'dropdown');
        this._onChange = this._getConfigParam('onChange', false);
        this._hasIcons = this._getConfigParam('hasIcons', true);
        this._forceDropdown = this._getConfigParam('forceDropdown', false);
        this._responsiveClass = this._getConfigParam('responsiveClass', false);
        this._headerClass = this._getConfigParam('headerClass', false);
        this._responsiveHeaderClass = this._getConfigParam('responsiveHeaderClass', false);
    },

    _initComponentElement($super) {
        $super();

        if (this._items.length && (this._forceDropdown || this._items.length > 1)) {
            this._updateComponentElement(
                '<a class="btn dropdown-toggle" href="#">' +
                    `<span>${this._getConfigParam('title')}</span>` +
                    ' <em class="caret"></em>' +
                '</a>' +
                `<ul id="${this._contentAreaId}" class="dropdown-menu dropdown-menu-flip${this._hasIcons ? ' dropdown-icon-menu' : ''}"></ul>`
            );
            this._componentElement.addClassName(this._cls);
        } else {
            this._componentElement = new Element('span', {
                id: this._id,
            }).update(this._getConfigParam('title'));
        }
    },

    _addEvents($super) {
        $super();

        this._componentElement.observe('click', function (event) {
            if ($$(`.${this._headerClass}`).first().hasClassName('r-show-main-header-navbar')) {
                event.stopPropagation();
            }
        }.bind(this));

        const boxElement = this._componentElement.down('.dropdown-toggle');
        if (boxElement) {
            DropdownManager.register(
                boxElement,
                function () {
                    return boxElement.up('.dropdown').hasClassName('open');
                },
                function () {
                    boxElement.up('.dropdown').addClassName('open');
                },
                function () {
                    boxElement.up('.dropdown').removeClassName('open');
                }
            );
        }

        this._addResponsiveEvents();
    },

    _addResponsiveEvents() {
        if (this._responsiveClass) {
            const dropdown = this;
            const responsiveElement = $$(`.${this._responsiveClass}`)[0];
            $(document).observe('click', function () {
                dropdown._hide();
            });

            Event.observe(responsiveElement, 'click', function (event) {
                dropdown._show(responsiveElement);
                event.stopPropagation();
            });
        }
    },

    _hide() {
        $$(`.${this._headerClass}`).first().className = this._headerClass;
        $$('.r-item-active').invoke('removeClassName', 'r-item-active');
        $$('.r-page-sidebar-search-active').invoke('removeClassName', 'r-page-sidebar-search-active');
    },

    _show(el) {
        let needShow = true;
        if (el.hasClassName('r-item-active')) {
            needShow = false;
        }

        this._hide();
        if (needShow) {
            $$(`.${this._headerClass}`).first().addClassName(this._responsiveHeaderClass);
            el.addClassName('r-item-active');
        }
    },

    _renderItem(item) {
        if (!$(this._contentAreaId)) {
            return;
        }
        const dropdownItem = new DropdownItem(item);

        const attributes = {
            href: item.href ? item.href : '#',
        };
        if (item.target) {
            attributes.target = item.target;
        }

        if (item.dataType) {
            attributes['data-type'] = item.dataType;
        }

        const valueItem = new Element('a', attributes).update(
            (item.iconClass ? `<i class="${item.iconClass}"></i>` : '') +
            dropdownItem.title.escapeHTML()
        );
        if (item.description) {
            Tooltip.init(valueItem, { text: item.description });
        }

        const liElement = new Element('li');
        if (this._getConfigParam('title') === dropdownItem.title.escapeHTML()) {
            liElement.addClassName('current');
        }
        liElement.appendChild(valueItem);
        $(this._contentAreaId).insert(liElement);

        if (item.disabled) {
            liElement.addClassName('disabled');
            valueItem.observe('click', function (event) {
                event.stop();
            });
        } else if (this._onChange) {
            valueItem.observe('click', this._onChange.bindAsEventListener(this, dropdownItem));
        }
    },
});



// WEBPACK FOOTER //
// ./jsw/responsive-dropdown.js